import React, { useContext } from 'react';
import { useTranslate } from '@bynder/localization';

import { IconLogout } from '@bynder/icons';
import { AbilityContext } from '../../abilities/Can';
import { CSRF } from '../../helpers/csrf';
import { iconSizeSmall } from '../../helpers/iconSizes';

export function LogoutItemOLD() {
	const ability = useContext(AbilityContext);
	const { translate } = useTranslate();

	const logoutUrl = ability.can('show', 'pynder_logout') ? '/pylogout/' : '/user/logout/';

	return (
		<form action={logoutUrl} method="post">
			<input type="hidden" name="csrf" value={CSRF} />
			<button type="submit" className="action-btn block blue">
				<IconLogout size={iconSizeSmall} /> {translate('generalLogout')}
			</button>
		</form>
	);
}
